/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_shipment = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbShipping_shipment">;
    readonly " $refType": "PdpRespSidebarBlurbs_shipment";
};
export type PdpRespSidebarBlurbs_shipment$data = PdpRespSidebarBlurbs_shipment;
export type PdpRespSidebarBlurbs_shipment$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_shipment$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_shipment">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_shipment",
  "type": "Shipment",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_shipment",
      "args": null
    }
  ]
};
(node as any).hash = '0520c02ebca9269dca1924ae0618c8f7';
export default node;
